import { useCurrentUser, useTasksDrawer } from '@qualio/ui-components';
import { EventStepStatus, QualityEventDetailsResponse } from '../types';
import { useTaskDetails } from './useTaskDetails';

export const useEventTaskDrawer = (
  eventData: QualityEventDetailsResponse | undefined,
  taskId: string | null,
  onClose: () => void,
): void => {
  const { companyId } = useCurrentUser();
  const { task, isTaskLoading } = useTaskDetails(companyId, Number(taskId), !!taskId);

  const taskStep = eventData?.steps.find((step) => step.id === task?.related_to_id);
  const isTaskStepNotOpen = !!taskStep && taskStep.status !== EventStepStatus.enum.open;

  useTasksDrawer(
    taskId && eventData && !isTaskLoading
      ? { taskId, viewOnly: eventData.issue.status !== 'open' || isTaskStepNotOpen }
      : null,
    onClose,
  );
};
